import React, { useState, useEffect, useRef } from 'react';
import img1 from '../images/material2.jpg';
import img2 from '../images/material1.jpg';
import img3 from '../images/material3.jpg';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Materials.css';

export default function Materials() {
  const [showModal, setShowModal] = useState(false);
  const textRef = useRef(null);
  const scrollYRef = useRef(0);

  useEffect(() => {
    if (showModal) {
      scrollYRef.current = window.scrollY;
      window.lenis?.stop();

      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollYRef.current}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
    } else {
      window.lenis?.start();

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";

      window.scrollTo(0, scrollYRef.current);
    }
  }, [showModal]);

  useEffect(() => {
    const el = textRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.remove('animate-in');
          void el.offsetWidth;
          el.classList.add('animate-in');
        }
      },
      { threshold: 0.5 }
    );

    if (el) observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);

  const settings = {
    infinite: true,
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    ltr: true,
    arrows: false,
    pauseOnHover: false,
  };

  const images = [img1, img2, img3, img1, img2, img3];

  return (
    <section className="materials-section">
      <div className="materials-container">
        <div className="materials-text" ref={textRef}>
          <h4>Materials</h4>
          <h2>Very Serious Materials &mdash;<br />Because Furniture Deserves It.</h2>
          <p>
            At Jooloo, we don’t just make furniture — we craft it with conviction.<br /><br />
            Every piece begins with one question: What belongs in a beautiful, long-lasting environment? The answer?<br />
            <b> Very serious materials.</b><br /><br />
            <em>Materials that respect nature, elevate design, and age gracefully with you.</em>
          </p>
          <button className="info-btn" onClick={() => setShowModal(true)}>
            More Info <span className="arrow">→</span>
          </button>
        </div>

        <div className="materials-images static-images">
          <img src={img1} alt="Material 1" className="mat-img img-top-left image-glass" />
          <img src={img2} alt="Material 2" className="mat-img img-bottom-left image-glass" />
          <img src={img3} alt="Material 3" className="mat-img img-right image-glass" />
        </div>

        <div className="materials-images slider-images">
          <Slider {...settings}>
            {images.map((img, index) => (
              <div key={index} className="mat-slide">
                <img src={img} alt={`Material ${index + 1}`} className="mat-img-slider image-glass" />
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-in" data-lenis-prevent>
            <button className="modal-close" onClick={() => setShowModal(false)}>×</button>

            <em>We source our materials from some of the world’s most reputable suppliers —
              yes, from a very expensive and famous capital — but we bring them to your space at a surprisingly grounded price.
              Why? Because we believe good design should be honest, and great materials shouldn't be locked behind luxury gates.
            </em> <br/> <br/>

            <h3>Wood – The Backbone</h3>
            <p>
              We use solid hardwoods like European Oak, American Walnut, and responsibly harvested Ash — selected for their natural character, durability, and structure.
              These aren’t mass-market veneers. Each timber is kiln-dried, aged, and hand-finished to bring out its true personality. No fake grains. No shortcuts.
              Just real wood with a real story.
            </p><br />

            <h3>Fabrics – Touch Matter</h3>
            <p>From textured natural linens to performance-rated woven blends, our upholstery materials are chosen for how they feel, wear, and behave over time.
              We partner with textile mills known for sustainable processes and timeless textures.
              These aren’t "fashion fabrics" — they’re fabrics meant to live with you, not fade in a year.
            </p><br />

            <h3>Metal & Hardware – Strength in Details</h3>
            <p>Every hinge, every leg, every welded joint matters.
              That’s why we use powder-coated steel, solid brass, or anodized aluminum — not just for strength, but for precision and presence.
              Even our fasteners are chosen not just to hold, but to last and look good doing it.
            </p><br />

            <h3>Finishings – Protection Meets Patina</h3>
            <p>Our wood finishes are water-based, VOC-free, and hand-applied in multiple layers to enhance the grain and protect against daily wear.
              Unlike plastic-looking lacquers, our finishes are designed to evolve over time — developing a soft patina that tells the story of your furniture's life with you.
            </p><br />

            <h3>The Jooloo Difference</h3>
            <p>While others cut corners, we cut joints with care. We build furniture that doesn't just survive the trends — it becomes part of the architecture of your life.
              So yes, we use very serious materials, because we take our craft — and your environment — very seriously.
            </p><br />
          </div>
          </div>
        </div>
      )}
    </section>
  );
}
